import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, KeyValuePair, FlatMode } from '../../models';

// Explicit import on purpose, does not work if imported from common/index
import { dashboardPeriods } from '../../common/dashboardPeriods';
import { aggregationModes, allTimeUnits, tableAggregationModes, timeUnits } from '../../common';

class WtSelectController implements angular.IComponentController, angular.IOnInit {
    field: string;
    model: string;
    properties: KeyValuePair<any, string>[];

    readonly changed: (value: any) => void;
    readonly disableTranslate: boolean;
    readonly disabled: boolean;
    readonly list: KeyValuePair<any, string>[];
    readonly required: boolean;
    readonly selectType: string;

    static $inject = [];

    $onInit() {
        if (!this.field) {
            this.field = 'selectProperty';
        }
        const props: { key: number; value: string }[] = [];

        switch (this.selectType) {
            case 'aggregationMode':
                this.properties = aggregationModes;
                break;
            case 'tableAggregationMode':
                this.properties = tableAggregationModes;
                break;
            case 'timeUnit':
                this.properties = timeUnits;
                break;
            case 'allTimeUnit':
                this.properties = allTimeUnits;
                break;
            case 'dashboardPeriod':
                this.properties = dashboardPeriods.map(d => d);
                break;
            case 'flatMode':
                for (const mode of Object.keys(FlatMode)) {
                    if (typeof FlatMode[mode] === 'number') {
                        props.push({
                            key: FlatMode[mode] as any,
                            value: mode
                        });
                    }
                }
                this.properties = props;
                break;
            case 'supplied':
                break;
            default:
                break;
        }
    }

    change(value: any) {
        if (this.changed) {
            this.changed({ value: value });
        }
    }
}

export const wtSelect: ComponentDefinition = {
    componentId: 'wtSelect',
    template: require('./select.component.html'),
    controller: WtSelectController,
    controllerAs: 'vm',
    bindings: {
        changed: '&?',
        disableTranslate: '<?',
        field: '@?',
        formController: '=?',
        isDisabled: '<?',
        model: '=',
        placeholder: '@?',
        properties: '<?',
        required: '<?',
        selectType: '@',
    }
};